import { render, staticRenderFns } from "./FormularioAreaListaPrecio.vue?vue&type=template&id=06274fe5"
import script from "./FormularioAreaListaPrecio.vue?vue&type=script&lang=js"
export * from "./FormularioAreaListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports